import { createContext, useContext } from 'react';

export const CART_TOASTER_ID = 'cart';

// Sonner sends a toast carrying a toasterId only to the Toaster with that id,
// and a toast without one only to Toasters that have no id. Cart toasts are
// scoped so that a page mounting its own Toaster does not render them twice.
// An app that already mounts one Toaster on every page supplies undefined
// here instead, so cart toasts join that stack rather than a second one
// pinned to the same corner.
//
// Carpenter takes this default. It mounts one React root per .react-component,
// and the cart callers in guide steps and product cards sit in roots with no
// CartDrawerProvider, so their toasts have to reach the <Toaster id="cart"> that
// CartDrawerProvider portals to document.body from the header root. One webpack
// build means one sonner module across roots, which is what lets a toast cross
// a root boundary. A page with a cart button and no carpenter header drops the
// toast with no error.
const CartToasterContext = createContext<string | undefined>(CART_TOASTER_ID);

export const CartToasterProvider = CartToasterContext.Provider;

export function useCartToasterId() {
   return useContext(CartToasterContext);
}
